import { LocationState, Path } from 'history';
import { scrollToTop } from '../../common/helpers/viewport';
import useRouter from './useRouter';
import { useIsBellaPageType } from './UrlManager/pageTypeHooks';

const useBellaPush = () => {
    const router = useRouter();
    const isBellaPageType = useIsBellaPageType();

    const bellaPush: NavigationPush = (
        to: Path,
        replace?: boolean,
        state?: LocationState,
        preventScroll: boolean = false
        // eslint-disable-next-line max-params
    ) => {
        const { isBellaPage } = isBellaPageType(to);
        const isExternalLink = !isBellaPage;
        // Check if we want to push a state, so that we do not do service navigation in remote header
        if (!state && (isExternalLink || router.disableClientsideNavigation)) {
            if (replace) {
                window.location.replace(to);
            } else {
                window.location.assign(to);
            }
            return;
        }

        if (!state && !preventScroll) {
            scrollToTop();
        }

        if (replace) {
            router.history.replace(to, state);
        } else {
            router.history.push(to, state);
        }
    };

    return bellaPush;
};

export type NavigationPush = (to: Path, replace?: boolean, state?: LocationState, preventScroll?: boolean) => void;

export default useBellaPush;
